import produce from 'immer';
import {
  FETCH_EVENTS_REQUESTED,
  FETCH_EVENTS_SUCCEED,
  FETCH_EVENTS_FAIL,

  FETCH_TOP_PRO_LINK_REQUESTED,
  FETCH_TOP_PRO_LINK_SUCCEED,
  FETCH_TOP_PRO_LINK_FAIL,

  FETCH_CLIENT_FUNNEL_REQUESTED,
  FETCH_CLIENT_FUNNEL_SUCCEED,
  FETCH_CLIENT_FUNNEL_FAIL,
  FETCH_STATISTIC_SUCCEED,
  FETCH_STATISTIC_FAIL,
  FETCH_STATISTIC_REQUESTED,
  UPDATE_EVENT
} from './actionTypes';

const initialState = {
  events: [],
  isEventsLoading: false,
  error: null
}
const AnalyticsErrors = {
  fetchEventsFailed: 'Не удалось обновить список событий.',
  editEventFailed: 'Не удалось сохранить данные события.'
}

const analyticsReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_EVENTS_REQUESTED:
      draft.error = null
      draft.isEventsLoading = true
      draft.error = null
      return draft

    case FETCH_EVENTS_SUCCEED:
      draft.isEventsLoading = false
      draft.events = action.events
      return draft

    case FETCH_EVENTS_FAIL:
      draft.isEventsLoading = false
      draft.error = action.error
      return draft

    case UPDATE_EVENT:
      // eslint-disable-next-line no-case-declarations
      const updatedEvents = draft.events || []
      // eslint-disable-next-line no-case-declarations
      const editedEvent = action.event
      for (let i = 0; i < updatedEvents.length; i++) {
        if (updatedEvents[i].id === editedEvent.id) {
          console.log('update candidate:')
          console.log(updatedEvents[i])

          updatedEvents[i] = editedEvent

          console.log('new value:')
          console.log(updatedEvents[i])
        }
      }
      draft.events = updatedEvents
      return draft




    case FETCH_TOP_PRO_LINK_REQUESTED:
      draft.error = null
      draft.isEventsLoading = true
      draft.error = null
      return draft

    case FETCH_TOP_PRO_LINK_SUCCEED:
      draft.isEventsLoading = false
      draft.events = action.events
      return draft

    case FETCH_TOP_PRO_LINK_FAIL:
      draft.isEventsLoading = false
      draft.error = action.error
      return draft

    case FETCH_STATISTIC_REQUESTED:
      draft.error = null
      draft.isEventsLoading = true
      draft.error = null
      return draft

    case FETCH_STATISTIC_SUCCEED:
      draft.isEventsLoading = false
      draft.events = action.events
      return draft

    case FETCH_STATISTIC_FAIL:
      draft.isEventsLoading = false
      draft.error = action.error
      return draft

     case FETCH_CLIENT_FUNNEL_REQUESTED:
      draft.error = null
      draft.isEventsLoading = true
      draft.error = null
      return draft

    case FETCH_CLIENT_FUNNEL_SUCCEED:
      draft.isEventsLoading = false
      draft.events = action.events
      return draft

    case FETCH_CLIENT_FUNNEL_FAIL:
      draft.isEventsLoading = false
      draft.error = action.error
      return draft

    default:
      return draft
  }
})

export default analyticsReducer



// WEBPACK FOOTER //
// ./src/store/analytics/reducer.js